export const contactConfig = {
  address: {
    line1: "Av. República del Salvador N35-82 y Portugal",
    line2: "Edif. Twin Towers, piso 11, ofic. A-B-C",
    city: "Quito, Ecuador",
  },
  tech: {
    label: "Operaciones y Soporte 24/7",
    phones: ["+593 2 244 2372", "+593 2 244 2373"],
    email: "soporte@captec.com.ec",
  },
  commercial: {
    label: "Comercial y Alianzas",
    phones: ["+593 99 850 7767"],
    // The review requests a generic institutional mailbox, but does not confirm one.
    // Keep the existing working address until Captec supplies the replacement.
    email: "smoran@captec.com.ec",
  },
  mapsUrl: "https://www.google.com/maps?sll=-0.180788,-78.479876&q=-0.18074129387955573,+-78.47985534128125+&z=17",
  mapsEmbedUrl: "https://www.google.com/maps?q=-0.18074129387955573,-78.47985534128125&z=17&output=embed",
  // TODO_LINKEDIN_URL_REQUIRES_CLIENT_CONFIRMATION
  linkedinUrl: null,
  // TODO_EMAIL_PROVIDER_CONFIGURATION — frontend-only submission until provider configured.
  emailProvider: null,
};
